// The published workflow definition WEB-0 drives end-to-end (seeded on the stack).
export const REFERRAL_INTAKE_API_NAME = 'referral_intake';

export const INBOUND_REFERRALS_ROUTES = {
  BASE: '/inbound-referrals',
  NEW: '/inbound-referrals/new',
};

// The demographic pills surfaced at the top of the page (design §4). These are
// declared value names — snake_case, sent verbatim — not API field names.
export const DEMOGRAPHIC_FIELDS = [
  { name: 'first_name', label: 'First name', type: 'text' as const },
  { name: 'last_name', label: 'Last name', type: 'text' as const },
  { name: 'date_of_birth', label: 'Date of birth', type: 'date' as const },
];
